/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useState, useContext, useEffect } from "react";
import ComissionTemplate from "./ComissionTemplate";
import { validateEmail } from "../../../CommonMethods/EmailValidator";
import CardHeader from "../../../components/CardHeader";
// import Input from "../../../components/InputBox";
import Button from "../../../components/Button";
import { dataService } from "../../../services/data.services";
import GlobalContext from "../../../components/Context/GlobalContext";
import { useNavigate, useParams } from "react-router-dom";
import ErrorMessage from "../../../components/ErrorMessage";
import LoadingOverlay from 'react-loading-overlay-ts';
import FloatingInput from "../../../components/FloatinInput";
import CardHeaders from "../../../components/CardHeaders";

export default function OnboardMerchant({ edit }) {
    const { setToastmessage, setToastErrorMessage } = useContext(GlobalContext)
    const [loading, setloading] = useState(false);
    const [invalidEmail, setinvalidEmail] = useState('');
    const [editData, seteditdata] = useState({})
    const { id, email } = useParams()
    const [errorState, seterrorState] = useState({});
    const [submitSelected, setsubmitSelected] = useState(false);
    const [DuplicateItems, setDuplicateItems] = useState([])
    const [tempData, setTempData] = useState({})
    const navigate = useNavigate()
    const [error, setError] = useState("");
    const [paymentData, setPaymentData] = useState({
        crypto: [],
        fiat: [],
        crypto_enabled: false,
        fiat_enabled: false
    });
    const [shippingEnabled, setShippingEnabled] = useState(false);

    const cryptoObject = [
        {
            url: '/assets/images/tether-usdt-icon.svg',
            name: 'Tether',
            key: 'USDT'
        },
        {
            url: '/assets/images/bitcoin.svg',
            name: 'Bitcoin',
            key: 'BTC'
        },
        {
            url: '/assets/images/dogecoin-doge-icon.svg',
            name: 'Dogecoin',
            key: 'DOGE'
        },
        {
            url: '/assets/images/filecoin-fil-icon.svg',
            name: 'Filecoin',
            key: 'FIL'
        },
        {
            url: '/assets/images/Cardano.svg',
            name: 'Cardano',
            key: 'ADA'
        },
        {
            url: '/assets/images/eutherium.svg',
            name: 'Ethereum',
            key: 'ETH'
        },
        {
            url: '/assets/images/Binance.svg',
            name: 'Binance',
            key: 'BNB'
        },
        {
            url: '/assets/images/eos-seeklogo.com 1.svg',
            name: 'EOS',
            key: 'EOS'
        },
        {
            url: '/assets/images/cosmos-atom-seeklogo.com 1.svg',
            name: 'Cosmos',
            key: 'ATOM'
        },
        {
            url: '/assets/images/ripple.svg',
            name: 'Ripple',
            key: 'XRP'
        }
    ]

    const fiatObject = [
        {
            url: '/assets/images/We-chatpay.svg',
            name: 'WeChat Pay',
            key: 'WeChat Pay'
        },
        {
            url: '/assets/images/union.svg',
            name: 'UnionPay',
            key: 'UnionPay WAP'
        },
        {
            url: '/assets/images/paypal.svg',
            name: 'PayPal',
            key: 'PayPal'
        },
        {
            url: '/assets/images/alipay.svg',
            name: 'Alipay+',
            key: 'Alipay+'
        },
        {
            url: '/assets/images/card.svg',
            name: 'Credit Card',
            key: 'Credit Card'
        }
    ];

    const [state, setstate] = useState(
        {
            "name": "",
            "business_name": "",
            "company_website": "",
            "address": "",
            "city": "",
            "postal_code": "",
            "phone_number": "",
            "store_different_address": "yes",
            "email_address": "",
            "user_type": "merchant_user"
        });
    const valueBasedObj = {
        "items": [{
            "min_cart_value": "",
            "max_cart_value": "",
            "commission": "",
            "commission_type": ""
        }]
    }
    const getData = async () => {
        try {
            let res = await dataService.GetAPI(`merchant-users/${email}`);
            seteditdata(res.data);

            delete res.data['adminuser_id'];
            delete res.data['status'];
            delete res.data['_id'];

            res.data["user_type"] = "admin_user",

            setTempData(res?.data)
            setstate(res?.data);
            
            // Set payment data from API response
            if (res.data.available_payment_methods) {
                setPaymentData({
                    crypto: res.data.available_payment_methods.crypto || [],
                    fiat: res.data.available_payment_methods.online || [],
                    crypto_enabled: res.data.available_payment_methods.crypto?.length > 0,
                    fiat_enabled: res.data.available_payment_methods.online?.length > 0
                });
            }
            
            setShippingEnabled(res.data.enable_shipping || false);
        } catch (error) {
            setToastErrorMessage(error.message)
            console.log(error.message,'jfjnnnnn')
        }

    }

    useEffect(() => {
        if (edit) {
            getData()
        }
    }, [])

    const handleType = (key, type) => {
        // Reset submitSelected to hide errors when changing commission type
        setsubmitSelected(false);
        
        const stateCopy = { ...state };
        stateCopy[type] = {}
        if (key === 'value_based_commision') {
            delete stateCopy['commission_percentage'];
            stateCopy[type] = valueBasedObj
            stateCopy[type].type = key

        } else {
            delete stateCopy[type]['items'];
            stateCopy[type] = {}
            stateCopy[type] = {
                type: key,
                commission_percentage: ''

            }
        }
        setstate(stateCopy)
    }
    

    const handleAddMultiItems = (type, del, idx) => {
        const Copy = { ...state };
        if (del) {
            Copy[type].items.splice(idx, 1)
        } else {
            Copy[type].items.push({
                "min_cart_value": "",
                "max_cart_value": "",
                "commission": "",
                "commission_type": ""
            });
        }
        setstate(Copy)
    }
    const handleInput = (key, value) => {
        const phoneNumberRegex = /^\+?\d{0,15}$/;
        const nameEx = /^[a-zA-Z0-9\s_]*$/;
        if (key === 'city' && value !== '') {
            if (!/^[a-zA-Z\s_]*$/.test(value)) {
                return
            }
        }
        if ((key === 'name' || key === 'business_name') && value !== '') {
            if (!nameEx.test(value)) {
                return
            }
        }
        setstate((prv) => ({
            ...prv,
            [key]: value,
        }));
    };

    const handleCryptoCheckbox = (cryptoName) => {
        const updatedCrypto = [...paymentData.crypto];
        const index = updatedCrypto.indexOf(cryptoName);

        if (index === -1) {
            updatedCrypto.push(cryptoName);
        } else {
            updatedCrypto.splice(index, 1);
        }
        
        const updatedData = { 
            ...paymentData, 
            crypto: updatedCrypto,
            crypto_enabled: updatedCrypto.length > 0
        };
        setPaymentData(updatedData);
        
        // Reset submitSelected to hide errors when changing selections
        setsubmitSelected(false);
        
        // Set/remove crypto commission based on selection
        const stateCopy = { ...state };
        if (updatedCrypto.length > 0) {
            if (!stateCopy.crypto_payment_commision) {
                stateCopy.crypto_payment_commision = {
                    type: 'fixed_percentage',
                    commission_percentage: ''
                };
            }
        } else {
            delete stateCopy.crypto_payment_commision;
        }
        setstate(stateCopy);
    }

    const handleFiatCheckbox = (fiatName) => {
        const updatedFiat = [...paymentData.fiat];
        const index = updatedFiat.indexOf(fiatName);

        if (index === -1) {
            updatedFiat.push(fiatName);
        } else {
            updatedFiat.splice(index, 1);
        }
        
        const updatedData = { 
            ...paymentData, 
            fiat: updatedFiat,
            fiat_enabled: updatedFiat.length > 0
        };
        setPaymentData(updatedData);
        
        // Reset submitSelected to hide errors when changing selections
        setsubmitSelected(false);
        
        // Set/remove commission types based on selected fiat payment methods
        const fiatPaymentToCommissionMap = {
            'WeChat Pay': 'wechat_payment_commision',
            'UnionPay WAP': 'unionpay_payment_commision',
            'PayPal': 'paypal_payment_commision',
            'Alipay+': 'alipay_payment_commision',
            'Credit Card': 'creditcard_payment_commision'
        };
        
        const stateCopy = { ...state };
        
        // Remove commission data only for unselected payment methods
        Object.entries(fiatPaymentToCommissionMap).forEach(([paymentMethod, commissionType]) => {
            if (!updatedFiat.includes(paymentMethod)) {
                delete stateCopy[commissionType];
            }
        });
        
        // Add commission data for selected payment methods with default selection
        updatedFiat.forEach(fiat => {
            const commissionType = fiatPaymentToCommissionMap[fiat];
            if (commissionType && !stateCopy[commissionType]) {
                stateCopy[commissionType] = {
                    type: 'fixed_percentage',
                    commission_percentage: ''
                };
            }
        });
        
        setstate(stateCopy);
    }

    const handleCryptoToggle = (enabled) => {
        const updatedData = {
            ...paymentData,
            crypto_enabled: enabled,
            crypto: enabled ? paymentData.crypto : []
        };
        setPaymentData(updatedData);
        
        // Clear crypto commission when toggle is disabled
        if (!enabled) {
            const stateCopy = { ...state };
            delete stateCopy.crypto_payment_commision;
            setstate(stateCopy);
        }
    }

    const handleFiatToggle = (enabled) => {
        const updatedData = {
            ...paymentData,
            fiat_enabled: enabled,
            fiat: enabled ? paymentData.fiat : []
        };
        setPaymentData(updatedData);
        
        // Clear all fiat commissions when toggle is disabled
        if (!enabled) {
            const stateCopy = { ...state };
            const fiatCommissionTypes = ['wechat_payment_commision', 'unionpay_payment_commision', 'paypal_payment_commision', 'alipay_payment_commision', 'creditcard_payment_commision'];
            fiatCommissionTypes.forEach(commissionType => {
                delete stateCopy[commissionType];
            });
            setstate(stateCopy);
        } else {
            // When fiat toggle is enabled, set commission for selected fiat payments
            const fiatPaymentToCommissionMap = {
                'WeChat Pay': 'wechat_payment_commision',
                'UnionPay WAP': 'unionpay_payment_commision',
                'PayPal': 'paypal_payment_commision',
                'Alipay+': 'alipay_payment_commision',
                'Credit Card': 'creditcard_payment_commision'
            };
            
            const stateCopy = { ...state };
            updatedData.fiat.forEach(fiat => {
                const commissionType = fiatPaymentToCommissionMap[fiat];
                if (commissionType && !stateCopy[commissionType]) {
                    stateCopy[commissionType] = {
                        type: 'fixed_percentage',
                        commission_percentage: ''
                    };
                }
            });
            setstate(stateCopy);
        }
    }

    const handleShippingToggle = (enabled) => {
        setShippingEnabled(enabled);
    }
    const handleItemInput = (e, type, index, drop) => {
        const replica = { ...state }
        if (drop) {
            replica[type].items[index]['commission_type'] = drop.value;
            // Reset commission value when commission type changes
            replica[type].items[index]['commission'] = '';
        } else {
            const { id, value } = e.target;
            replica[type].items[index][id] = value;
        }
        setstate(replica)
    }
    const handleFixedPrice = (e, type) => {
        
        const numEx = /^\d*\.?\d*$/;
        const value = parseFloat(e.target.value);

        if (!numEx.test(e.target.value) || (e.target.value !== '' && (isNaN(value) || value > 100))) {
            return;
        }
        const fixedCopy = { ...state };
        fixedCopy[type].commission_percentage = e.target.value;
        setstate(fixedCopy)


    }
    const handleValidation = () => {
        const errors = {}
        const mykeys = {
            "name": "",
            "business_name": "",
            "company_website": "",
            "address": "",
            "city": "",
            "postal_code": "",
            "phone_number": "",
            "email_address": "",
        }
        Object.keys(mykeys).forEach((item) => {
            if (typeof state[item] === 'object' ? state[item].length === 0 : state[item] === '') {
                errors[item] = 'This field is mandatory'
            }
        })
        
        seterrorState(errors)
        return Object.keys(errors).length === 0
    }
    function validateUniqueCommissionValues(commissionValues) {
        // Create a set to store the unique commission values.
        const uniqueCommissionValues = [];
        const duplicateKey = []

        // Iterate over the commission values and add them to the set.
        for (const commissionValue of commissionValues) {
            // Only validate if commission fields have values
            if (commissionValue.min_cart_value && commissionValue.max_cart_value && 
                commissionValue.commission && commissionValue.commission_type &&
                commissionValue.min_cart_value.trim() !== '' && commissionValue.max_cart_value.trim() !== '' &&
                commissionValue.commission.trim() !== '' && commissionValue.commission_type.trim() !== '') {
                const key = `${commissionValue.min_cart_value}-${commissionValue.max_cart_value}-${commissionValue.commission_type}-${commissionValue.commission}`;
                if (uniqueCommissionValues.includes(key)) {
                    duplicateKey.push(key)
                }
                uniqueCommissionValues.push(key);
            }
        }        // If all of the commission values are unique, return true.
        return duplicateKey;
    }
    function validateMinMaxValue(commissionValues) {
        const minMaxError = []

        for (const commissionValue of commissionValues) {
            // Only validate if both values are provided and not empty
            if (commissionValue.min_cart_value && commissionValue.max_cart_value && 
                commissionValue.min_cart_value.trim() !== '' && commissionValue.max_cart_value.trim() !== '') {
                if (Number(commissionValue.max_cart_value) <= Number(commissionValue.min_cart_value))
                    minMaxError.push(commissionValue.max_cart_value);
            }
        }
        return minMaxError;
    }
    function validateCommissionFields(commissionValues) {
        // Check if any row has partial data (some fields filled but not all)
        for (const commissionValue of commissionValues) {
            const minCartValue = commissionValue.min_cart_value?.toString().trim() || '';
            const maxCartValue = commissionValue.max_cart_value?.toString().trim() || '';
            const commission = commissionValue.commission?.toString().trim() || '';
            const commissionType = commissionValue.commission_type?.toString().trim() || '';
            
            const hasAnyValue = minCartValue !== '' || maxCartValue !== '' || commission !== '' || commissionType !== '';
            
            if (hasAnyValue) {
                // If any field has a value, all fields must be filled
                const allFieldsFilled = minCartValue !== '' && maxCartValue !== '' && commission !== '' && commissionType !== '';
                
                if (!allFieldsFilled) {
                    return false; // Invalid: partial data found
                }
            }
        }
        return true; // All commission rows are either empty or fully filled
    }

    // Helper function to check if a commission is properly configured
    function isCommissionConfigured(commissionData) {
        if (!commissionData) {
            return false;
        }
        
        // Check for fixed percentage commission
        if (commissionData.type === 'fixed_percentage') {
            return commissionData.commission_percentage && 
                   commissionData.commission_percentage.toString().trim() !== '' &&
                   !isNaN(parseFloat(commissionData.commission_percentage)) &&
                   parseFloat(commissionData.commission_percentage) > 0;
        }
        
        // Check for value-based commission - require at least one complete row
        if (commissionData.type === 'value_based_commision' && commissionData.items) {
            // Check if at least one item is fully configured
            for (const item of commissionData.items) {
                const minCartValue = item.min_cart_value?.toString().trim() || '';
                const maxCartValue = item.max_cart_value?.toString().trim() || '';
                const commission = item.commission?.toString().trim() || '';
                const commissionType = item.commission_type?.toString().trim() || '';
                
                if (minCartValue !== '' && maxCartValue !== '' && commission !== '' && commissionType !== '') {
                    // Validate that max > min
                    if (Number(maxCartValue) > Number(minCartValue)) {
                        return true; // At least one valid commission item found
                    }
                }
            }
            return false; // No complete commission items found
        }
        
        return false; // No valid commission configuration found
    }
    const handleSubmit = async (e) => {

        e.preventDefault()
        setloading(true)
        setDuplicateItems([])
        setinvalidEmail('')
        setsubmitSelected(true);
        
        // Payment method validation
        const hasCryptoSelections = paymentData.crypto?.length > 0;
        const hasFiatSelections = paymentData.fiat?.length > 0;
        const cryptoEnabled = paymentData.crypto_enabled;
        const fiatEnabled = paymentData.fiat_enabled;
        
        if (!cryptoEnabled && !fiatEnabled) {
            setToastErrorMessage('Please select a payment method');
            setloading(false)
            return
        }
        
        if (cryptoEnabled && !hasCryptoSelections) {
            setToastErrorMessage('Please select at least one cryptocurrency payment method');
            setloading(false)
            return
        }
        
        if (fiatEnabled && !hasFiatSelections) {
            setToastErrorMessage('Please select at least one fiat payment method');
            setloading(false)
            return
        }

        // Map fiat payment methods to their commission types and display names
        const fiatPaymentToCommissionMap = {
            'WeChat Pay': {
                commissionType: 'wechat_payment_commision',
                displayName: 'WeChat Pay'
            },
            'UnionPay WAP': {
                commissionType: 'unionpay_payment_commision',
                displayName: 'UnionPay'
            },
            'PayPal': {
                commissionType: 'paypal_payment_commision',
                displayName: 'PayPal'
            },
            'Alipay+': {
                commissionType: 'alipay_payment_commision',
                displayName: 'Alipay'
            },
            'Credit Card': {
                commissionType: 'creditcard_payment_commision',
                displayName: 'Credit Card'
            }
        };

        // Collect all payment methods missing commissions
        const missingCommissions = [];

        // Validate crypto commission if crypto payment methods are selected
        if (hasCryptoSelections) {
            const cryptoCommissionData = state.crypto_payment_commision;
            if (!isCommissionConfigured(cryptoCommissionData)) {
                missingCommissions.push('Crypto');
            }
        }

        // Validate that each selected fiat payment method has a corresponding commission
        if (hasFiatSelections) {
            for (const selectedFiat of paymentData.fiat) {
                const paymentInfo = fiatPaymentToCommissionMap[selectedFiat];
                if (paymentInfo) {
                    const commissionData = state[paymentInfo.commissionType];
                    if (!isCommissionConfigured(commissionData)) {
                        missingCommissions.push(paymentInfo.displayName);
                    }
                }
            }
        }

        // Show error if any commissions are missing
        if (missingCommissions.length > 0) {
            setloading(false);
            const firstCommissionElement = document.querySelector('[data-commission-section]');
            if (firstCommissionElement) {
                firstCommissionElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            return;
        }
        
        // Validate commission fields completeness (all fields must be filled if any field has value)
        const commissionTypes = ['crypto_payment_commision', 'creditcard_payment_commision', 'wechat_payment_commision', 'unionpay_payment_commision', 'paypal_payment_commision', 'alipay_payment_commision'];
        
        for (const commissionType of commissionTypes) {
            if (state?.[commissionType]?.items) {
                const isValid = validateCommissionFields(state[commissionType].items);
                if (!isValid) {
                    setloading(false);
                    // setToastErrorMessage('Please fill all commission fields (minimum cart value, maximum cart value, commission type, and commission) for each commission row');
                    window.scrollTo(0, 0);
                    return;
                }
            }
        }

        if (state?.crypto_payment_commision?.items) {
            const arrayCopy = validateUniqueCommissionValues(state.crypto_payment_commision.items);
            const cryptoMinMax = validateMinMaxValue(state.crypto_payment_commision.items)

            if (arrayCopy.length > 0) {
                setDuplicateItems(arrayCopy);
                setloading(false);
                return
            }
            if (cryptoMinMax.length > 0) {
                setloading(false);
                return
            }
        }
        if (state?.creditcard_payment_commision?.items) {
            const arr = validateUniqueCommissionValues(state.creditcard_payment_commision.items);
            const cardMinMax = validateMinMaxValue(state.creditcard_payment_commision.items)
            if (arr.length > 0) {
                setDuplicateItems(arr);
                setloading(false);
                return
            }
            if (cardMinMax.length > 0) {
                setloading(false);
                return
            }
        }
        // Validate all fiat commission types
        const fiatCommissionTypes = ['wechat_payment_commision', 'unionpay_payment_commision', 'paypal_payment_commision', 'alipay_payment_commision'];
        
        for (const commissionType of fiatCommissionTypes) {
            if (state?.[commissionType]?.items) {
                const fiatArray = validateUniqueCommissionValues(state[commissionType].items);
                const fiatMinMax = validateMinMaxValue(state[commissionType].items);

                if (fiatArray.length > 0) {
                    setDuplicateItems(fiatArray);
                    setloading(false);
                    return
                }
                if (fiatMinMax.length > 0) {
                    setloading(false);
                    return
                }
            }
        }

        if (!handleValidation()) {
            setloading(false);
            // Scroll to first error field
            const firstErrorField = document.querySelector('.input-error');
            if (firstErrorField) {
                firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            return
        }

        if (validateEmail(state.email_address.trim())) {
            setloading(false);
            return
        }
        
        try {
            let body = { ...state };
            
            // Remove empty commission data (already validated above, so this is just cleanup)
            const commissionTypesToClean = ['crypto_payment_commision', 'creditcard_payment_commision', 'wechat_payment_commision', 'unionpay_payment_commision', 'paypal_payment_commision', 'alipay_payment_commision'];
            
            commissionTypesToClean.forEach(commissionType => {
                if (body[commissionType]) {
                    // For value_based_commision with items
                    if (body[commissionType].items) {
                        const hasValidItems = body[commissionType].items.some(item => 
                            item.min_cart_value?.trim() || item.max_cart_value?.trim() || 
                            item.commission?.trim() || item.commission_type?.trim()
                        );
                        if (!hasValidItems) {
                            delete body[commissionType];
                        }
                    }
                    // For fixed_percentage
                    else if (body[commissionType].type === 'fixed_percentage' && 
                             (!body[commissionType].commission_percentage || body[commissionType].commission_percentage.trim() === '')) {
                        delete body[commissionType];
                    }
                }
            });
            
            // Prepare available payment methods data
            const availablePaymentMethods = {};
            if (hasCryptoSelections) {
                availablePaymentMethods.crypto = paymentData.crypto;
            }
            if (hasFiatSelections) {
                availablePaymentMethods.online = paymentData.fiat;
            }
            
            body.available_payment_methods = availablePaymentMethods;
            body.enable_shipping = shippingEnabled;
            
            let response;
            if (edit) {
                response = await dataService.PatchAPI(body, `merchant-users/update/${email}`);
                navigate(-1);
            } else {
                response = await dataService.PostAPI(body, `merchant-users/create`);
                navigate('/manage-merchants')
            }
            setToastmessage(`Merchant ${edit ? 'updated' : 'onboarded'} successfully`)
        } catch (error) {
            setloading(false);
            window.scrollTo(0, 0)
            if (error?.response?.status == 400) {
                const errorMessage = error.response.data.message;
                // Filter out commission validation errors as they should be handled on frontend
                const isCommissionError = errorMessage && (
                    errorMessage.toLowerCase().includes('commission') ||
                    errorMessage.toLowerCase().includes('cart value') ||
                    errorMessage.toLowerCase().includes('commission type')
                );
                
                if (errorMessage.includes('email') || errorMessage.includes('Email')) {
                    seterrorState({
                        'email_address': 'This email address already exists.Please try a different one'
                    })
                } else if (isCommissionError) {
                    // Commission errors should be caught by frontend validation
                    // If we still get one, show a generic message
                    setToastErrorMessage('Please ensure all commission fields are filled correctly')
                } else {
                    setToastErrorMessage(errorMessage)
                }
            } else {
                const errorMessage = error.response?.data?.message || error.message;
                // Filter out commission validation errors
                const isCommissionError = errorMessage && (
                    errorMessage.toLowerCase().includes('commission') ||
                    errorMessage.toLowerCase().includes('cart value') ||
                    errorMessage.toLowerCase().includes('commission type')
                );
                
                if (isCommissionError) {
                    setToastErrorMessage('Please ensure all commission fields are filled correctly')
                } else {
                    setToastErrorMessage(errorMessage)
                }
            }
        }
    }

    return (
        // <CardHeader header={edit ? 'Edit Merchnat' : "Onboard Merchant"}
        //     path={edit ? "Manage Merchants/Edit Merchant" : "Manage Merchants/Onboard Merchant"}
        //     back="/manage-merchants">
        <CardHeaders paths={['Manage Merchants']} pathurls={['/manage-merchants']} activePath={edit ? 'Edit Merchant' : "Onboard Merchantr"} header={edit ? 'Edit Merchnat' : "Onboard Merchant"} back="/manage-merchants">

            <LoadingOverlay
                active={edit ? Object.keys(editData).length === 0 : false}
                spinner
                text='Loading Merchant details...'
            >
                <div className="bg-[#f5f5f5] pl-[15px] pb-[14px] pt-[14px]">
                    <form onSubmit={handleSubmit}>
                        <div className="bg-white px-4 h-customh10 overflow-y-scroll scrollHide">
                            <div className=" pt-8 mb-6">
                                <p className="  text-xl font-medium text-[#4B4B4B]">
                                    Merchant Information 
                                </p>
                            </div>
                            <div className="pt-4 pl-5 pb-3 border border-[#EB9DC7] mb-8 rounded-[4px]">
                                <div className="flex space-x-[38px] mb-6">
                                    <div className="w-1/3 relative">
                                        {/* <Input
                                        type="text"
                                        state={state}
                                        id="name"
                                        handleInput={handleInput}
                                        submitSelected={submitSelected}
                                        setsubmitSelected={setsubmitSelected}
                                        className={`${submitSelected && state.name === '' ? 'input-error' : 'input-border'} px-4 py-4 w-[100%] border border-[#DDDDDD] placeholder:text-sm placeholder:font-semibold placeholder:text-[#1F1F1F]`}
                                        text="This field is mandatory"

                                        maxLength="30"
                                        placeholder="Merchant name"

                                    /> */}
                                        <FloatingInput
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            value={state.name}
                                            maxLength={50}
                                            id="name"
                                            handleInput={handleInput}
                                            state={state.name}
                                            classKey={`${submitSelected && state.name === ""
                                                ? "input-error"
                                                : "input-border"
                                            // eslint-disable-next-line max-len
                                            } w-full px-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer`}
                                            labelCalss={`${submitSelected && (state.name === '' || (errorState['name'] && errorState['name'] !== '')) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-4 absolute text-[#1F1F1F] block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-1 peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4`}
                                            // errorImage="email-error.svg"
                                            // normalImage="email.svg"
                                            text="Merchant name"
                                            errorState={errorState}
                                            placeholder={edit ? ' ' : ''}
                                        
                                        />
                                    </div>
                                    <div className="w-1/3 relative">
                                        {/* <Input
                                        type="text"
                                        state={state}
                                        id="business_name"
                                        handleInput={handleInput}
                                        submitSelected={submitSelected}
                                        setsubmitSelected={setsubmitSelected}
                                        className={`${submitSelected && state.business_name === '' ? 'input-error' : 'input-border'} px-4 py-4 w-[100%] border border-[#DDDDDD] placeholder:text-sm placeholder:font-semibold placeholder:text-[#1F1F1F]`}
                                        text="This field is mandatory"

                                        maxLength="30"
                                        placeholder="Business name"

                                    /> */}
                                        <FloatingInput
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            value={state.business_name}
                                            id="business_name"
                                            maxLength={50}
                                            handleInput={handleInput}
                                            state={state.business_name}
                                            classKey={`${submitSelected && state.business_name === ""
                                                ? "input-error"
                                                : "input-border"
                                            // eslint-disable-next-line max-len
                                            } w-full px-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer`}
                                            labelCalss={`${submitSelected && (state.business_name === '' || (errorState['business_name'] && errorState['business_name'] !== '')) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-4 absolute text-[#1F1F1F] block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-1 peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4`}
                                            // errorImage="email-error.svg"
                                            // normalImage="email.svg"
                                            text="Business name"
                                            errorState={errorState}
                                            placeholder={edit ? ' ' : ''}
                                        
                                        />
                                    </div>
                                </div>
                                <div className="flex space-x-[38px] mb-6">
                                    <div className="w-1/3 relative">
                                        {/* <Input
                                        type="text"
                                        state={state}
                                        id="company_website"
                                        handleInput={handleInput}
                                        submitSelected={submitSelected}
                                        setsubmitSelected={setsubmitSelected}
                                        className={`${submitSelected && state.company_website === '' ? 'input-error' : 'input-border'} px-4 py-4 w-[100%] border border-[#DDDDDD] placeholder:text-sm placeholder:font-semibold placeholder:text-[#1F1F1F]`}
                                        text="This field is mandatory"

                                        maxLength="30"
                                        placeholder="Company website"

                                    /> */}
                                        <FloatingInput
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            value={state.company_website}
                                            id="company_website"
                                            maxLength={50}
                                            handleInput={handleInput}
                                            state={state.company_website}
                                            classKey={`${submitSelected && state.company_website === ""
                                                ? "input-error"
                                                : "input-border"
                                            // eslint-disable-next-line max-len
                                            } w-full px-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer`}
                                            labelCalss={`${submitSelected && (state.company_website === '' || (errorState['company_website'] && errorState['company_website'] !== '')) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-4 absolute text-[#1F1F1F] block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-1 peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4`}
                                            // errorImage="email-error.svg"
                                            // normalImage="email.svg"
                                            text="Company website"
                                            errorState={errorState}
                                            placeholder={edit ? ' ' : ''}
                                        
                                        />
                                    </div>
                                    <div className="w-1/3 relative">
                                        {/* <Input
                                        type="number"
                                        state={state}
                                        id="phone_number"
                                        handleInput={handleInput}
                                        submitSelected={submitSelected}
                                        setsubmitSelected={setsubmitSelected}
                                        className={`${submitSelected && (state.phone_number === '' && (state.phone_number.length > 0 !== 10)) ? 'input-error' : 'input-border'} px-4 py-4 w-[100%] border border-[#DDDDDD] placeholder:text-sm placeholder:font-semibold placeholder:text-[#1F1F1F]`}
                                        text="This field is mandatory"
                                        maxLength="10"
                                        placeholder="Phone number"

                                    /> */}
                                        <FloatingInput
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            value={state.phone_number}
                                            id="phone_number"
                                            maxLength={16}
                                            handleInput={handleInput}
                                            state={state.phone_number}
                                            classKey={`${submitSelected && state.phone_number === ""
                                                ? "input-error"
                                                : "input-border"
                                            // eslint-disable-next-line max-len
                                            } w-full px-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer`}
                                            labelCalss={`${submitSelected && (state.phone_number === '' || (errorState['phone_number'] && errorState['phone_number'] !== '')) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-4 absolute text-[#1F1F1F] block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-1 peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4`}
                                            // errorImage="email-error.svg"
                                            // normalImage="email.svg"
                                            text="Phone number"
                                            errorState={errorState}
                                            inputType="number"
                                            placeholder={edit ? ' ' : ''}
                                        
                                        />
                                        {/* {submitSelected&&state.phone_number!==''&&state.phone_number.length!==10&&<ErrorMessage error message="Invalid phone number" />} */}

                                    </div>
                                </div>
                                <div className="flex space-x-[38px] mb-6">
                                    <div className="w-1/3 relative">

                                        <FloatingInput
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            value={state.address}
                                            id="address"
                                            maxLength={100}
                                            handleInput={handleInput}
                                            state={state.address}
                                            classKey={`${submitSelected && state.address === ""
                                                ? "input-error"
                                                : "input-border"
                                            // eslint-disable-next-line max-len
                                            } w-full px-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer`}
                                            labelCalss={`${submitSelected && (state.address === '' || (errorState['address'] && errorState['address'] !== '')) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-4 absolute text-[#1F1F1F] block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-1 peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4`}
                                            // errorImage="email-error.svg"
                                            // normalImage="email.svg"
                                            text="Address"
                                            errorState={errorState}
                                            placeholder={edit ? ' ' : ''}
                                        
                                        />
                                    </div>
                                    <div className="w-1/3 relative">

                                        <FloatingInput
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            value={state.city}
                                            id="city"
                                            maxLength={50}
                                            handleInput={handleInput}
                                            state={state.city}
                                            classKey={`${submitSelected && state.city === ""
                                                ? "input-error"
                                                : "input-border"
                                            // eslint-disable-next-line max-len
                                            } w-full px-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer`}
                                            labelCalss={`${submitSelected && (state.city === '' || (errorState['city'] && errorState['city'] !== '')) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-4 absolute text-[#1F1F1F] block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-1 peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4`}
                                            // errorImage="email-error.svg"
                                            // normalImage="email.svg"
                                            text="City"
                                            errorState={errorState}
                                            placeholder={edit ? ' ' : ''}
                                        
                                        />
                                    </div>
                                </div>
                                <div className="flex space-x-[38px] mb-6">
                                    <div className="w-1/3 relative">

                                        <FloatingInput
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            value={state.postal_code}
                                            id="postal_code"
                                            maxLength={12}
                                            handleInput={handleInput}
                                            state={state.postal_code}
                                            classKey={`${submitSelected && state.postal_code === ""
                                                ? "input-error"
                                                : "input-border"
                                            // eslint-disable-next-line max-len
                                            } w-full px-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer`}
                                            labelCalss={`${submitSelected && (state.postal_code === '' || (errorState['postal_code'] && errorState['citpostal_codey'] !== '')) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-4 absolute text-[#1F1F1F] block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-1 peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4`}
                                            // errorImage="email-error.svg"
                                            // normalImage="email.svg"
                                            text="Postal code"
                                            errorState={errorState}
                                            placeholder={edit ? ' ' : ''}
                                        />
                                    </div>
                                    <div className="w-1/3 relative">
                                        <FloatingInput
                                            setsubmitSelected={setsubmitSelected}
                                            submitSelected={submitSelected}
                                            value={state.email_address}
                                            id="email_address"
                                            maxLength={64}
                                            handleInput={handleInput}
                                            state={state.email_address}
                                            classKey={`${submitSelected &&
                                            (state.email_address === "" ||
                                                validateEmail(state.email_address.trim()) || error || errorState['email_address'])
                                                ? "input-error"
                                                : "input-border"
                                            } ${edit ? 'text-[#1F1F1F]' : '[#1F1F1F]'} w-full px-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer`}
                                            labelCalss={`${submitSelected &&
                                            (state.email_address === "" ||
                                                validateEmail(state.email_address.trim()) || error || errorState['email_address'])
                                                ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} ${edit ? 'text-[#ABABAB]' : '[#1F1F1F]'} px-4 absolute text-[#1F1F1F] block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-1 peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4`}
                                            // errorImage="email-error.svg"
                                            // normalImage="email.svg"
                                            text="Email address"
                                            errorState={errorState}
                                            placeholder={edit ? ' ' : ''}
                                            disabled={edit}
                                            readonly={edit}

                                        />

                                        {submitSelected &&
                                        state.email_address !== "" &&
                                        validateEmail(
                                            state.email_address || invalidEmail !== "") && (<ErrorMessage message="Invalid email address" error classKey={'itext-f4 text-sm font-normal text-[#FC4523] mt-[8px] login-err'} />
                                        )}
                                        {/* {submitSelected &&
                                        errorState['email_address'] !== '' && (<ErrorMessage message={errorState['email_address']} error />
                                        )} */}
                                        {submitSelected && error !== "" && (
                                            <ErrorMessage message={error} error />
                                        )}
                                        {/* {submitSelected && state.email_address !== '' && validateEmail(state.email_address.trim()) && <ErrorMessage error message="Invalid email address" />} */}
                                    </div>
                                </div>
                                {/* <div>
                            <input
                                className="float-left    mr-[6px] mt-[0.15rem] h-[1.125rem] w-[1.125rem] appearance-none rounded-[0.25rem] border-[0.125rem] border-solid border-[#9E2064] outline-none before:pointer-events-none before:absolute before:h-[0.875rem] before:w-[0.875rem] before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] checked:border-primary checked:bg-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:-mt-px checked:after:ml-[0.25rem] checked:after:block checked:after:h-[0.8125rem] checked:after:w-[0.375rem] checked:after:rotate-45 checked:after:border-[0.125rem] checked:after:border-l-0 checked:after:border-t-0 checked:after:border-solid checked:after:border-white checked:after:bg-transparent checked:after:content-[''] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:transition-[border-color_0.2s] focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-[0.875rem] focus:after:w-[0.875rem] focus:after:rounded-[0.125rem] focus:after:content-[''] checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:after:-mt-px checked:focus:after:ml-[0.25rem] checked:focus:after:h-[0.8125rem] checked:focus:after:w-[0.375rem] checked:focus:after:rotate-45 checked:focus:after:rounded-none checked:focus:after:border-[0.125rem] checked:focus:after:border-l-0 checked:focus:after:border-t-0 checked:focus:after:border-solid checked:focus:after:border-white checked:focus:after:bg-transparent dark:border-neutral-600 dark:checked:border-primary dark:checked:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]"
                                type="checkbox"
                                value={state.store_different_address}
                                onChange={(e)=>handleInput(e)}
                                id="store_different_address"
                            />
                            <label className="inline-block pl-[1rem] hover:cursor-pointer text-base font-normal text-[#1F1F1F]">
                                Store has a different physical address
                            </label>
                        </div> */}
                            </div>

                            {/* Shipping Section */}
                            <div className='mt-8'>
                                <div className='flex items-center'>
                                    <span className='text-[#1F1F1F] text-base font-normal pr-4'>Enable Shipping</span>
                                    <div className="status custom-toggle flex items-center">
                                        <label className="switch">
                                            <input
                                                type="checkbox"
                                                checked={shippingEnabled}
                                                onChange={(e) => handleShippingToggle(e.target.checked)}
                                            />
                                            <span className={`${shippingEnabled ? "bg-[#FBEBF4] border border-[#9e2064]" : "bg-white border border-[#dddddd]"} slider round`}></span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            {/* Cryptocurrency Payments */}
                            <div className=' border-[#E0E0E0] pt-14 pb-6'>
                                <div className='flex items-center mb-4'>
                                    <span className='text-[#1F1F1F] text-base font-normal pr-4'>Enable Cryptocurrency Payments</span>
                                    <div className="status custom-toggle flex items-center">
                                        <label className="switch">
                                            <input
                                                type="checkbox"
                                                checked={paymentData?.crypto_enabled || false}
                                                onChange={(e) => handleCryptoToggle(e.target.checked)}
                                            />
                                            <span className={`${paymentData?.crypto_enabled ? "bg-[#FBEBF4] border border-[#9e2064]" : "bg-white border border-[#dddddd]"} slider round`}></span>
                                        </label>
                                    </div>
                                </div>
                                
                                {paymentData?.crypto_enabled && (
                                    <div className='bg-[#FBEBF4] p-3 rounded-lg mb-3'>
                                        <div className='grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4'>
                                            {cryptoObject && cryptoObject?.map((item, index) => (
                                                <label htmlFor={`crypto-${index}`} className='cursor-pointer' key={item?.name}>
                                                    <div className='py-3 px-4 rounded-lg hover:border-[#9E2064] transition-colors'>
                                                        <div className='flex items-center space-x-2 sm:space-x-3'>
                                                            <div className="relative">
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={() => handleCryptoCheckbox(item?.key)}
                                                                    className="appearance-none w-[18px] h-[18px] border-[1.5px] border-[#9E2064] rounded cursor-pointer flex-shrink-0 checked:bg-[#9E2064] checked:border-[#9E2064]"
                                                                    id={`crypto-${index}`}
                                                                    checked={paymentData?.crypto?.includes(item?.key)}
                                                                />
                                                                {paymentData?.crypto?.includes(item?.key) && (
                                                                    <svg className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-[70%] w-[18px] h-[18px] pointer-events-none" viewBox="0 0 20 20" fill="white">
                                                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                                    </svg>
                                                                )}
                                                            </div>
                                                            <img src={item?.url} alt="" className='w-9 h-9 flex-shrink-0' />
                                                            <span className='text-sm truncate'>{item?.name}</span>
                                                        </div>
                                                    </div>
                                                </label>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Fiat Payments */}
                            <div className='border-y border-[#E0E0E0] pt-14 pb-6 mb-8'>
                                <div className='flex items-center mb-4'>
                                    <span className='text-[#1F1F1F] text-base font-normal pr-4'>Enable Fiat Payments</span>
                                    <div className="status custom-toggle flex items-center">
                                        <label className="switch">
                                            <input
                                                type="checkbox"
                                                checked={paymentData?.fiat_enabled || false}
                                                onChange={(e) => handleFiatToggle(e.target.checked)}
                                            />
                                            <span className={`${paymentData?.fiat_enabled ? "bg-[#FBEBF4] border border-[#9e2064]" : "bg-white border border-[#dddddd]"} slider round`}></span>
                                        </label>
                                    </div>
                                </div>
                                
                                {paymentData?.fiat_enabled && (
                                    <div className='bg-[#FBEBF4] p-3 rounded-lg mb-4'>
                                        <div className='grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 '>
                                            {fiatObject && fiatObject?.map((item, index) => (
                                                <label htmlFor={`fiat-${index}`} className='cursor-pointer' key={item?.name}>
                                                    <div className='py-3 px-4 rounded-lg hover:border-[#9E2064] transition-colors'>
                                                        <div className='flex items-center space-x-2 sm:space-x-3'>
                                                            <div className="relative">
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={() => handleFiatCheckbox(item?.key)}
                                                                    className="appearance-none w-[18px] h-[18px] mt-1.5 border-[1.5px] border-[#9E2064] rounded cursor-pointer flex-shrink-0 checked:bg-[#9E2064] checked:border-[#9E2064]"
                                                                    id={`fiat-${index}`}
                                                                    checked={paymentData?.fiat?.includes(item?.key)}
                                                                />
                                                                {paymentData?.fiat?.includes(item?.key) && (
                                                                    <svg className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-[50%] w-[18px] h-[18px] pointer-events-none" viewBox="0 0 20 20" fill="white">
                                                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                                    </svg>
                                                                )}
                                                            </div>
                                                            <img src={item?.url} alt="" className='w-[70px] h-9 flex-shrink-0' />
                                                        </div>
                                                    </div>
                                                </label>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Crypto Payment Commission */}
                            <div className="mb-6" data-commission-section>
                                <p className="text-xl font-medium text-[#4B4B4B]">
                                    Crypto Payment Commission
                                </p>
                            </div>
                            <div className="mb-6">
                                <ComissionTemplate state={state} handleType={handleType} type="crypto_payment_commision" handleAddMultiItems={handleAddMultiItems}
                                    submitSelected={submitSelected}
                                    setsubmitSelected={setsubmitSelected}
                                    handleFixedPrice={handleFixedPrice}
                                    DuplicateItems={DuplicateItems}
                                    setDuplicateItems={setDuplicateItems}
                                    loading={loading}
                                    handleInput={handleItemInput}
                                    paymentData={paymentData} />
                            </div>

                            {/* Fiat Payment Commissions */}
                            <div className="mb-6">
                            
                                {/* WeChat Pay Commission */}
                                <div className="mb-6">
                                    <p className="text-xl font-medium text-[#4B4B4B] mb-4">
                                        WeChat Commission
                                    </p>
                                    <ComissionTemplate state={state} handleType={handleType} type="wechat_payment_commision" handleAddMultiItems={handleAddMultiItems}
                                        submitSelected={submitSelected}
                                        setsubmitSelected={setsubmitSelected}
                                        handleFixedPrice={handleFixedPrice}
                                        DuplicateItems={DuplicateItems}
                                        setDuplicateItems={setDuplicateItems}
                                        loading={loading}
                                        handleInput={handleItemInput}
                                        paymentData={paymentData} />
                                </div>


                                {/* UnionPay Commission pay*/}
                                <div className="mb-6">
                                    <p className="text-xl font-medium text-[#4B4B4B] mb-4">
                                        Union Pay Commission
                                    </p>
                                    <ComissionTemplate state={state} handleType={handleType} type="unionpay_payment_commision" handleAddMultiItems={handleAddMultiItems}
                                        submitSelected={submitSelected}
                                        setsubmitSelected={setsubmitSelected}
                                        handleFixedPrice={handleFixedPrice}
                                        DuplicateItems={DuplicateItems}
                                        setDuplicateItems={setDuplicateItems}
                                        loading={loading}
                                        handleInput={handleItemInput}
                                        paymentData={paymentData} />
                                </div>

                                {/* PayPal Commission */}
                                <div className="mb-6">
                                    <p className="text-xl font-medium text-[#4B4B4B] mb-4">
                                        PayPal Commission
                                    </p>
                                    <ComissionTemplate state={state} handleType={handleType} type="paypal_payment_commision" handleAddMultiItems={handleAddMultiItems}
                                        submitSelected={submitSelected}
                                        setsubmitSelected={setsubmitSelected}
                                        handleFixedPrice={handleFixedPrice}
                                        DuplicateItems={DuplicateItems}
                                        setDuplicateItems={setDuplicateItems}
                                        loading={loading}
                                        handleInput={handleItemInput}
                                        paymentData={paymentData} />
                                </div>

                                {/* Alipay+ Commission */}
                                <div className="mb-6">
                                    <p className="text-xl font-medium text-[#4B4B4B] mb-4">
                                        Alipay Commission
                                    </p>
                                    <ComissionTemplate state={state} handleType={handleType} type="alipay_payment_commision" handleAddMultiItems={handleAddMultiItems}
                                        submitSelected={submitSelected}
                                        setsubmitSelected={setsubmitSelected}
                                        handleFixedPrice={handleFixedPrice}
                                        DuplicateItems={DuplicateItems}
                                        setDuplicateItems={setDuplicateItems}
                                        loading={loading}
                                        handleInput={handleItemInput}
                                        paymentData={paymentData} />
                                </div>

                                {/* Credit Card Commission */}
                                <div className="mb-6">
                                    <p className="text-xl font-medium text-[#4B4B4B] mb-4">
                                        Credit Card Commission
                                    </p>
                                    <ComissionTemplate state={state} handleType={handleType} type="creditcard_payment_commision" handleAddMultiItems={handleAddMultiItems}
                                        submitSelected={submitSelected}
                                        setsubmitSelected={setsubmitSelected}
                                        handleFixedPrice={handleFixedPrice}
                                        DuplicateItems={DuplicateItems}
                                        setDuplicateItems={setDuplicateItems}
                                        loading={loading}
                                        handleInput={handleItemInput}
                                        paymentData={paymentData} />
                                </div>
                            </div>

                        

                            {/* Payment Methods Section */}
                            <div className="mb-6">
                                {/* <p className="text-xl font-medium text-[#4B4B4B] mb-6">
                                Payment Methods
                            </p> */}
                            
                            
                            </div>

                            <div className="mb-6">
                                <Button
                                    handleClick={handleSubmit}
                                    loading={loading}
                                    disabled={loading}
                                    text={edit ? "Update" : "Onboard"}
                                    classKey={`px-[136px] text-white py-[10px]  rounded-[12px]  bg-primary`}
                                    type="submit"
                                    testId="onboard"
                                />

                            </div>
                        </div>
                    </form>
                </div>
            </LoadingOverlay>
        </CardHeaders>
    );
}

